// extracted by mini-css-extract-plugin
export var breadcrumb = "_1m-3";
export var breadcrumbArrow = "_1m-4";
export var breadcrumbs = "_1m-0";
export var link = "_1m-5";
export var sm = "_1m-1";
export var xs = "_1m-2";